import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Axios from "axios";
import { Row, Col, Button, Modal } from "react-bootstrap";
import { isBrowser } from "react-device-detect";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as OrderDetailsStyles from "../../styles/yourOrders/orderDetails";

//COMPONENTS
import OrderDetailsItemFullPrice from "./orderDetailsItemFullPrice";
import OrderDetailsItemDeposit from "./orderDetailsItemDeposit";
import OrderDetailsRepaidItem from "./orderDetailsRepaidItem";

function OrderDetails() {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const [viewConfirmationBtn, setViewConfirmationBtn] = useState("Order Confirmation");

    const modalDefaultValues = {
        open: false
    };

    const [modal, setModal] = useState(modalDefaultValues);

    function handleModalClose() {
        setModal(modalDefaultValues);
    }

    const [details, setDetails] = useState({});
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        loadData();
    }, [params.id]);

    function loadData() {
        const data = { id: params.id };
        Axios.post("/pods/3dPrintingShop/orders/getOrderDetails", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setDetails(data.details);
                    setItems(data.items);
                    setLoaded(true);
                }
            })
            .catch((err) => console.log(err));
    }

    function handlePrintingProgressClick() {
        navigate("./printingProgress");
    }

    function handleViewOrderConfirmination() {
        console.log("Order Details: ", details);
        const data = { orderID: details.uuid };
        setViewConfirmationBtn("Preparing ...");

        Axios.post("/pods/3dPrintingShop/frontEnd/profile/produceOrderConfirmationPDF", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal((prevState) => {
                        return { ...prevState, open: true };
                    });
                } else {
                    console.log("Fetch Error!");
                }
            })
            .catch((err) => console.log(err));
    }

    function pdfLoaded(filename) {
        const data = { filename: filename };

        Axios.post("/pods/3dPrintingShop/orders/deleteTempPDF", data)
            .then((res) => {
                const data = res.data;
                setViewConfirmationBtn("Order Confirmation");
            })
            .catch((err) => console.log(err));
    }

    const browserDisplay = (
        <div style={OrderDetailsStyles.body}>
            <Row>
                <Col sm={1}></Col>
                <Col>
                    {loaded && (
                        <div>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col style={OrderDetailsStyles.columnRight}>
                                            <strong>Order ID:</strong> {details.id}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <strong>Customer:</strong> {details.userDetails.fullName} <br />
                                            <strong>Email: </strong> {details.userDetails.email} <br />
                                            <strong>Telephone: </strong> {details.userDetails.tel} <br /> <br />
                                            <strong>Address: </strong> <br />
                                            {details.userDetails.addressLine1} <br />
                                            {details.userDetails.addressLine2} <br />
                                            {details.userDetails.town} <br />
                                            {details.userDetails.postcode} <br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <br />
                                            {details.depositItems && (
                                                <div style={OrderDetailsStyles.redText}>
                                                    This order contain items which you are paying deposits for. The remianing ammount will be due when
                                                    half the the model is built
                                                </div>
                                            )}
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Sub Total:</strong>
                                                </Col>
                                                <Col sm={4}>£{(details.subTotal / 100).toFixed(2)}</Col>
                                            </Row>
                                            <br />
                                            {details.coupon.active && (
                                                <div>
                                                    <Row>
                                                        <Col style={OrderDetailsStyles.columnRight}>
                                                            <strong>Coupon: </strong>
                                                            {details.coupon.code} ({details.coupon.description}):
                                                        </Col>
                                                        <Col sm={4}>-£{(details.coupon.takenOffAmount / 100).toFixed(2)}</Col>
                                                    </Row>
                                                    <br />
                                                </div>
                                            )}
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Postage:</strong>
                                                </Col>
                                                <Col sm={4}>
                                                    {details.postage.name} (£{(details.postageWhenOrdered / 100).toFixed(2)})
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={OrderDetailsStyles.columnRight}>
                                                    <strong>Total:</strong>
                                                </Col>
                                                <Col sm={4}>£{(details.orderTotal / 100).toFixed(2)}</Col>
                                            </Row>
                                            {details.depositItems ? (
                                                <div>
                                                    <hr />
                                                    <Row>
                                                        <Col style={OrderDetailsStyles.columnRight}>
                                                            <strong>Full Order Total:</strong>
                                                        </Col>
                                                        <Col sm={4}>£{(details.subTotalWithoutDeposits / 100).toFixed(2)}</Col>
                                                    </Row>
                                                    <Row>
                                                        <Col style={OrderDetailsStyles.columnRight}>
                                                            <strong>Amount Paid:</strong>
                                                        </Col>
                                                        <Col sm={4}>£{(details.subTotal / 100).toFixed(2)}</Col>
                                                    </Row>
                                                    <Row style={OrderDetailsStyles.redText}>
                                                        <Col style={OrderDetailsStyles.columnRight}>
                                                            <strong>Outstanding Amount:</strong>
                                                        </Col>
                                                        <Col sm={4}>£{(details.toPay / 100).toFixed(2)}</Col>
                                                    </Row>
                                                </div>
                                            ) : (
                                                <div></div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <strong>Items:</strong>
                                            <br /> <br />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {items.map((item, index) => {
                                                if (item.priceStatus == "dp") {
                                                    if (item.repaidItem) {
                                                        return <OrderDetailsRepaidItem key={index} item={item} />;
                                                    } else {
                                                        return <OrderDetailsItemDeposit key={index} item={item} />;
                                                    }
                                                } else {
                                                    return <OrderDetailsItemFullPrice key={index} item={item} />;
                                                }
                                            })}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm={3} style={OrderDetailsStyles.buttons}>
                                    <Button onClick={handlePrintingProgressClick}>Printing Progress</Button>
                                    <Button onClick={handleViewOrderConfirmination}>{viewConfirmationBtn}</Button>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Col>
                <Col sm={1}></Col>
            </Row>
        </div>
    );

    const mobileDisplay = (
        <div style={OrderDetailsStyles.mobile_body}>
            {loaded && (
                <div>
                    <div style={OrderDetailsStyles.columnRight}>
                        <strong>Order ID:</strong> {details.id}
                    </div>
                    <div>
                        <strong>Customer:</strong> {details.userDetails.fullName} <br />
                        <strong>Email: </strong> {details.userDetails.email} <br />
                        <strong>Telephone: </strong> {details.userDetails.tel} <br /> <br />
                        <strong>Address: </strong> <br />
                        {details.userDetails.addressLine1} <br />
                        {details.userDetails.addressLine2} <br />
                        {details.userDetails.town} <br />
                        {details.userDetails.postcode} <br />
                    </div>
                    <br />
                    {details.depositItems && (
                        <div style={OrderDetailsStyles.redText}>
                            This order contain items which you are paying deposits for. The remianing ammount will be due when half the the model is
                            built
                        </div>
                    )}
                    <br />
                    <div style={OrderDetailsStyles.mobile_totalsContainer}>
                        <div style={OrderDetailsStyles.mobile_totalsHeadings}>
                            <strong>Sub Total:</strong> <br />
                            {details.coupon.active ? (
                                <div>
                                    <strong>Coupon</strong> {details.coupon.code} ({details.coupon.description}): <br />
                                    <br />
                                </div>
                            ) : (
                                <br />
                            )}
                            <strong>Postage:</strong> <br />
                            <strong>Total:</strong>
                            {details.depositItems && (
                                <div>
                                    <hr style={{ color: "transparent" }} />
                                    <strong>Full Order Total:</strong> <br />
                                    <strong>Amount Paid:</strong> <br />
                                    <strong style={OrderDetailsStyles.redText}>Outstanding Amount:</strong>
                                </div>
                            )}
                        </div>
                        <div style={OrderDetailsStyles.mobile_totalsPrices}>
                            £{(details.subTotal / 100).toFixed(2)} <br />
                            {details.coupon.active ? (
                                <div>
                                    -£{(details.coupon.takenOffAmount / 100).toFixed(2)} <br /> <br />
                                </div>
                            ) : (
                                <br />
                            )}
                            {details.postage.name} (£{(details.postageWhenOrdered / 100).toFixed(2)}) <br />£{(details.orderTotal / 100).toFixed(2)}
                            {details.depositItems && (
                                <div>
                                    <hr />£{(details.subTotalWithoutDeposits / 100).toFixed(2)} <br />£{(details.subTotal / 100).toFixed(2)} <br />
                                    <div style={OrderDetailsStyles.redText}> £{(details.toPay / 100).toFixed(2)}</div>
                                </div>
                            )}
                        </div>
                    </div>
                    <br />
                    <div style={OrderDetailsStyles.mobile_buttonContainer}>
                        <Button onClick={handlePrintingProgressClick}>Printing Progress</Button>
                        <Button onClick={handleViewOrderConfirmination}>{viewConfirmationBtn}</Button>
                    </div>
                    <strong>Items:</strong> <br /> <br />
                    {items.map((item, index) => {
                        if (item.priceStatus == "dp") {
                            if (item.repaidItem) {
                                return <OrderDetailsRepaidItem key={index} item={item} />;
                            } else {
                                return <OrderDetailsItemDeposit key={index} item={item} />;
                            }
                        } else {
                            return <OrderDetailsItemFullPrice key={index} item={item} />;
                        }
                    })}
                </div>
            )}
        </div>
    );

    return (
        <div>
            {isBrowser ? browserDisplay : mobileDisplay}
            <Modal size="lg" show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        id="iframepdf"
                        width="100%"
                        height="500"
                        src={`${window.location.origin}/content/temp/test.pdf`}
                        onLoad={pdfLoaded.bind(this, "test.pdf")}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default OrderDetails;
